import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { HiOutlineUser, HiOutlineLockClosed } from 'react-icons/hi';
import { IoFastFoodSharp } from 'react-icons/io5';
import "./LoginForm.css"
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginMethod } from '../../hooks/auth';
import axios from 'axios';
import API_URL from '../../config/api';
function LoginForm() {
    const dispatch=useDispatch();
    const navigate=useNavigate();
  
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('');
const [loading, setLoading] = useState(false);
const handlesubmit = async (e) => {
  e.preventDefault();

  try {
    setLoading(true);

    const response = await axios.post(`${API_URL}/user/auth/login`, {
    username:  email,
      password
    });

    const data = response.data.data;
        dispatch(loginMethod(data));


    // // navigation حسب role
    if (data.user.role === "Super Admin") {
      navigate("/dashboard/Dashboard");
    } else if (data.user.role === "Trainee") {
      navigate("/dashboard/student-dashbord");
    }

  } catch (error) {
    console.log(error);

    if (error.response) {
      alert(error.response.data.message || "Login failed");
    } else {
      alert("Network error");
    }

  } finally {
    setLoading(false);
  }
};

//   const handlesubmit=(e)=>{
//         e.preventDefault();

//     if(email=="admin"){
//     navigate("/dashboard/Dashboard");
//         dispatch(loginMethod({
// userArray:{
//   token:"123456789",
//   user:{
//     role:"Super Admin"
//   }
// }
//         }));
//     }else if(email=="student"){
//     navigate("/dashboard/student-dashbord");
//         dispatch(loginMethod({
// userArray:{
//   token:"123456789",
//   user:{
//     role:"student"
//   }
// }
//         }));
//     }
//   }
  return (
    <div className="login-page-wrapper">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={12}>

            {/* Header Section */}
            <div className="text-center mb-4">
              <div className="brand-icon-box">
                <IoFastFoodSharp size={28} color="#005a32" />
              </div>
              <h2 className="fw-bold mt-3" style={{ color: '#1a1a1a' }}>ادارة مطاعم الاكاديمية </h2>
              <p className="text-muted">إدارة دقيقة للمطبخ العصري.</p>
            </div>

            {/* Login Card */}
            <Card className="border-0  p-4" style={{ borderRadius: '16px' }}>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold text-uppercase text-muted">
                       اسم المستخدم
                  </Form.Label>
                  <div className="input-group custom-input-group">

                    <Form.Control type="text" placeholder="e.g. chef.remy@academy.edu" value={email}onChange={(e)=>setEmail(e.target.value)}/>
                    <span className="input-group-text">
                      <HiOutlineUser size={18} />
                    </span>
                  </div>
                </Form.Group>

                <Form.Group className="mb-3">
                  <div className="d-flex justify-content-between">
                    <Form.Label className="small fw-bold text-uppercase text-muted">
                      كلمة المرور
                    </Form.Label>
                    {/* <a href="#" className="small academy-link">نسيت كلمة المرور؟</a> */}
                  </div>
                  <div className="input-group custom-input-group">

                    <Form.Control type="password" placeholder="••••••••"
                      value={password}
  onChange={(e) => setPassword(e.target.value)}

                    />
                    <span className="input-group-text">
                      <HiOutlineLockClosed size={18} />
                    </span>
                  </div>
                </Form.Group>



                <Button className="w-100 btn-secure-signup" 
  onClick={handlesubmit}
  disabled={loading}
>
  {loading ? "جاري تسجيل الدخول..." : "تسجيل الدخول الآمن →"}
</Button>         

                <div className="text-center my-4">
                  <hr className="text-muted opacity-25" />
          
                </div>


              </Form>
            </Card>

            {/* Footer */}

          </Col>
        </Row>
      </Container>
    </div>)
}

export default LoginForm